<div class="adaptive-grow-1">
  <div class="fluent-container">
    @if (showSearch && userSession) {
      <nav class="search-nav">
        <form [formGroup]="searchForm">
          <div class="form-grid">
            <mat-form-field appearance="fill" class="search-field" subscriptSizing="dynamic">
              <mat-icon matPrefix>search</mat-icon>

              <input matInput placeholder="Buscar..." formControlName="search" />
              @if (isLoadingInput) {
                <div class="spinner-overlay">
                  <mat-spinner diameter="24"></mat-spinner>
                </div>
              }
            </mat-form-field>
          </div>
        </form>
      </nav>
    }
  </div>
</div>
